var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaymentIconVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6a6 6 0 016-6h34a6 6 0 016 6v20a6 6 0 01-6 6H6a6 6 0 01-6-6V6z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.334 21.144h-2.747l-2.06-8.087c-.097-.373-.304-.702-.61-.857a8.764 8.764 0 00-2.517-.855v-.312h4.424c.61 0 1.069.468 1.145 1.011l1.068 5.834 2.745-6.845h2.67l-4.118 10.111zm5.645 0h-2.594l2.136-10.11h2.594l-2.136 10.11zm5.491-7.31c.077-.544.534-.856 1.069-.856a4.713 4.713 0 012.517.467l.458-2.177a6.402 6.402 0 00-2.365-.468c-2.517 0-4.349 1.4-4.349 3.344 0 1.479 1.298 2.255 2.214 2.723.99.467 1.372.778 1.296 1.244 0 .7-.763 1.011-1.525 1.011-.916 0-1.832-.233-2.67-.622l-.458 2.178c.916.388 1.906.544 2.822.544 2.823.077 4.577-1.322 4.577-3.422 0-2.645-3.586-2.8-3.586-3.966zm12.663 7.31l-2.06-10.11h-2.211a1.15 1.15 0 00-1.069.777l-3.813 9.333h2.67l.533-1.477h3.28l.306 1.477h2.364zm-3.89-7.388l.762 3.81H32.87l1.373-3.81z",
    fill: "#172B85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 1h34v-2H6v2zm39 5v20h2V6h-2zm-5 25H6v2h34v-2zM1 26V6h-2v20h2zm5 5a5 5 0 01-5-5h-2a7 7 0 007 7v-2zm39-5a5 5 0 01-5 5v2a7 7 0 007-7h-2zM40 1a5 5 0 015 5h2a7 7 0 00-7-7v2zM6-1a7 7 0 00-7 7h2a5 5 0 015-5v-2z",
    fill: "#F2F4F7"
  })));
}

export default SvgPaymentIconVisa;